import {ZohoPageInfo} from "./ZohoPageInfo";

export class ZohoResult<T> {
  data?: T;
  info = new ZohoPageInfo();
}
